module.exports = __webpack_public_path__ + "files/3aa7e26431bbdabf9f2ee5b281e5b223.png";